"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const supportQuery_1 = require("../../../../queries/supportQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const TIME_TO_LOAD_URL = 500;
const SupportPage = () => {
    const queryClient = (0, react_query_1.useQueryClient)();
    const { setPageLoading, setHeaderName } = (0, zustandStore_1.useZustand)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data, isLoading, isFetching } = (0, react_query_1.useQuery)({
        ...supportQuery_1.supportUrlQuery,
        initialData: initialData.supportUrl,
    });
    const { url = '' } = data || {};
    const [isReady] = (0, react_use_1.useTimeout)(TIME_TO_LOAD_URL);
    (0, react_router_1.useBeforeUnload)(() => {
        queryClient.removeQueries({
            queryKey: [supportQuery_1.supportKeys.getSupportUrl],
        });
        setPageLoading(false);
    });
    (0, react_1.useEffect)(() => {
        if (isLoading || isFetching) {
            setPageLoading(true);
        }
        else {
            setHeaderName('Tradeshift Go');
        }
    }, [isLoading, isFetching, setPageLoading, setHeaderName, queryClient]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)("div", { style: { width: '100%', height: '100vh', display: 'flex' }, children: url && isReady() ? ((0, jsx_runtime_1.jsx)("iframe", { style: { flex: 1 }, name: "page-support", onLoad: () => setPageLoading(false), src: url })) : null })] }));
};
exports.default = SupportPage;
